export default "__VITE_ASSET__ClWGG923__"